import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import React from "react";
import { Outlet, useRoute, useParams, useBCMSContext, BCMSRecord } from "@bcm-dev/bcms-vite";
import { Card } from "model";

import "./styles.css";
/**
 * @function ReportLostStolenPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ReportLostStolenPage
 */

export default function ReportLostStolenPage(props) {
  const controller = useBCMSContext();
  const navigate = useRoute();

  BCMSRecord.globalControllerFor([ Card ], controller);

  const cardID = useParams().cardID ?? "0";

  return (
    <MainContentContainer 
      className="report-lost-stolen-page" 
      header={
        <MainContentHeader text="Report Lost Stolen Page" onClick={ evt => navigate(`/home/recenttransactions/${ cardID }`) } />
      }>
      <Outlet />
    </MainContentContainer>
  );
}